import Image from "next/image";
import Link from "next/link";
import type { ReactNode } from "react";

const logo = (
  <Image
    src="/logo.svg"
    alt="Yolk"
    width={116}
    height={40}
    className="h-10 w-[115.702px]"
  />
);

export const TrainingHeader = ({
  title,
  subtitle,
  action,
  logoHref = "/",
}: {
  title?: string;
  subtitle?: string;
  action?: ReactNode;
  /** `null` = unlinked logo, keeps /try visitors in the flow. */
  logoHref?: string | null;
}) => {
  return (
    <div className="pb-2.5 p-0 md:p-5 w-full">
      <div className="md:bg-white md:border border-d-border flex flex-col items-start p-5 md:rounded-3xl md:shadow-sm">
        <div className="flex gap-8 items-center w-full">
          <div className="flex flex-1 gap-6 items-center min-w-0">
            <div className="flex items-center shrink-0">
              {logoHref === null ? logo : <Link href={logoHref}>{logo}</Link>}
            </div>
            <div className="hidden md:flex items-baseline gap-3 min-w-0 flex-1">
              <p className="font-semibold leading-7 shrink-0 text-d-black text-[22px] whitespace-nowrap">
                {title}
              </p>
              {subtitle ? (
                <p className="font-medium leading-5 text-d-gray text-[15px] truncate min-w-0">
                  {subtitle}
                </p>
              ) : null}
            </div>
          </div>
          {action}
        </div>
      </div>
    </div>
  );
};
